import { render, staticRenderFns } from "./TermsOfServiceNew.vue?vue&type=template&id=2c4a2a13&scoped=true&"
import script from "./TermsOfServiceNew.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceNew.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfServiceNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TermsOfServiceNew.vue?vue&type=style&index=1&id=2c4a2a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a2a13",
  null
  
)

export default component.exports